import MaterialLink from '@material-ui/core/Link';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {Breadcrumb} from 'Core/models/Breadcrumb';
import './BreadcrumbEntry.sass';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';

type BreadcrumbEntryProps = {
  breadcrumb: Breadcrumb;
  isCurrent: boolean;
};

const BreadcrumbEntry = (props: BreadcrumbEntryProps) => {
  const {breadcrumb, isCurrent} = props;
  const {title, path} = breadcrumb;
  const history = useHistory();

  return (
    <MaterialLink
      onClick={() => {
        history.push(path);
      }}
      className="breadcrumb-entry"
      color={isCurrent ? 'textPrimary' : 'inherit'}
      id={`breadcrumb-entry-${toKebabCase(title)}`}
      data-dd-privacy="mask"
    >
      {title}
    </MaterialLink>
  );
};

export default BreadcrumbEntry;
